import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks"
import { updateDescriptionField, updateUrsNo } from "../UrsSlice"
import { SaveButton } from "../../../app/components/SaveButton";
import { CloseButton } from "../../../app/components/CloseButton";

const Label = ({ fieldName }: { fieldName: "description" | "area" | "purpose" | "title" }) => {
    switch (fieldName) {
        case "description": return <Localized id='urs-description'>Opis</Localized>
        case "area": return <Localized id='urs-area'>Obszar</Localized>
        case "purpose": return <Localized id='urs-purpose'>Cel</Localized>
        case "title": return <Localized id='urs-title'>Tytuł</Localized>
    }
}

export interface EditDocNumberDialogProps {
    ursId: AppId
    value: string
    onSuccess: () => void
    onCancel: () => void
}

export const EditDocNumberDialog = (props: EditDocNumberDialogProps) => {
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const [value, setValue] = useState(props.value)

    const handleOkClick = () => {
        setSaving(true)
        dispatch(updateUrsNo({
            ursId: props.ursId,
            ursNo: value,
        }))
            .then(unwrapResult)
            .then(() => { props.onSuccess() })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setSaving(false)
            })
    }

    return <Dialog open={true} fullWidth maxWidth='sm'>
        <DialogTitle
            sx={{
                bgcolor: (theme) => theme.palette.grey[200],
                borderBottom: "1px solid",
                borderColor: "divider",
                py: 0.75,
            }}
        >
            <Localized id='edit'>Edycja</Localized>
        </DialogTitle>
        <DialogContent>
            <TextField
                sx={{ mt: 2 }}
                fullWidth
                value={value}
                onChange={e => setValue(e.target.value)}
                label={<Localized id='urs-number'>Numer URS</Localized>}
            />
        </DialogContent>
        <DialogActions>
            <SaveButton loading={saving} onClick={handleOkClick} />
            <CloseButton loading={saving} onClick={props.onCancel} />
        </DialogActions>
    </Dialog>
}
